
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-placed",
      function () {
        return require("private-next-pages/order-placed.tsx");
      }
    ]);
  